import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { fetchSiteSettings } from '../../../services/siteSettingsService';
import BackgroundSlideshow from './BackgroundSlideshow';

const HeroSection = () => {
  const navigate = useNavigate();
  const [verticalLogo, setVerticalLogo] = useState(null);

  useEffect(() => {
    // Fetch site logos
    const loadLogos = async () => {
      const { verticalLogo: logo } = await fetchSiteSettings();
      setVerticalLogo(logo);
    };

    loadLogos();
  }, []);

  return (
    <section id="hero" className="relative pt-16 pb-16 lg:pb-32 overflow-hidden">
      {/* Background Slideshow */}
      <BackgroundSlideshow />
      
      {/* Animated Background Gradients - made more transparent to show slideshow */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900/60 to-pink-900/60 pointer-events-none z-10">
        <div className="absolute top-20 left-10 w-96 h-96 bg-purple-500 rounded-full blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-pink-500 rounded-full blur-3xl opacity-30 animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>
      
      <div className="relative z-20 max-w-screen-xl mx-auto px-6 lg:px-8 pt-16">
        <div className="text-center">
          {/* Shakespeare Icon / Logo */}
          <div className="mb-8 flex justify-center">
            {verticalLogo && (
              <img 
                src={verticalLogo} 
                alt="BardPlay vertical logo" 
                className="w-72 h-72 object-contain"
              />
            )}
          </div>

          {/* Main Heading with Gradient */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-6 leading-tight">
            Master Shakespeare
            <span className="block gradient-text-pink mt-2">Like a Boss 🔥</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl lg:text-2xl text-white/90 mb-12 max-w-4xl mx-auto leading-relaxed">
            Stop struggling with old English! Our engaging mobile platform makes Shakespeare fun, fast, and totally understandable. Join the students who are already acing their English classes!
          </p>

          {/* CTA Button */}
          <div className="mb-16">
            <button
              onClick={() => navigate('/registration')}
              className="btn-primary text-lg px-12 py-5 inline-flex items-center gap-3"
            >
              <Icon name="Rocket" size={24} />
              Start Learning Free
            </button>
          </div>

          {/* Bottom Features Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto">
            {[
              { icon: 'Target', title: 'Spot on Shakespeare', subtitle: 'Understand every line' },
              { icon: 'TrendingUp', title: '3x faster', subtitle: 'comprehension rate' },
              { icon: 'Award', title: 'Improve test scores', subtitle: 'Get better grades' },
              { icon: 'Flame', title: 'Trending education app', subtitle: 'Join thousands' }
            ]?.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="mb-4 flex justify-center">
                  <Icon name={feature?.icon} size={32} className="text-white" />
                </div>
                <h3 className="text-white font-semibold text-lg mb-1">{feature?.title}</h3>
                <p className="text-white/70 text-sm">{feature?.subtitle}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;